import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {
  RiskAssessmentCodeAreaEnum,
  RiskAssessmentCodeResponse,
} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {RiskAssessmentCodeAreaPill} from 'src/shared/constants/PillConstants';
import {RiskAssessmentCodeAreaDataOptions} from 'src/shared/constants/columnFilterData';

export const useRiskAssessmentCodeColumns = () => {
  const columns = useMemo<MRT_ColumnDef<RiskAssessmentCodeResponse>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'internalIdentifier',
        header: 'Identifier',
      },
      {
        accessorKey: 'area',
        header: 'Area',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: RiskAssessmentCodeAreaDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<RiskAssessmentCodeAreaEnum>();
          const pillConfig = RiskAssessmentCodeAreaPill(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
    ],
    []
  );

  return columns;
};
